import React from 'react';
import nerveImg from '../img/nerve lifebank logo  1.png';
import appImg from '../img/as 1.png';
import gocImg from '../img/ps 1.png';
import scanImg from '../img/bit.ly_downloadnerveapp (1).png';
import './nerve.css';

const StoreLink = ({ store, image }) => {
  const storeUrl = store === 'appstore' ? 'https://apps.apple.com/ng/app/nerve-by-lifebank/id6451122858' : 'https://play.google.com/store/apps/details?id=com.lifebankdevs.nerve&hl=en&gl=ng';

  return (
    <a href={storeUrl} target='_blank' rel='noopener noreferrer'>
      <img src={image} alt='logo' />
    </a>
  );
};

const Nerve = () => {
  return (
    <div className='container'>
      <div className='page'>
        <img src={nerveImg} className='App-logo' alt='logo' />
        <p>
          Nerve makes it super easy and convenient for <br /> hospitals to order medical supplies
          <div className='page-p'></div>
        </p>
      </div>
      <div className='store-apps'>
        <StoreLink store='appstore' image={appImg} />
        <StoreLink store='googleplay' image={gocImg} />
      </div>
      <div className='footer'>
        <p>Scan the QR code to<br /> download Nerve on <br /> your devices</p>
        <img src={scanImg} className='scan-logo' alt='logo' />
      </div>
    </div>
  );
};

export default Nerve;
